/* AULBERY — Collection page
   assets/as-collection-page.js — the dialog + sort wiring that used to be
   inline in sections/as-collection-page.liquid, moved 1:1. The root is
   [data-as-collection-page]; its data-ascp-dialog-class names the class the
   section's two <dialog>s carry (they are siblings of the root).
   shopify:section:unload closes any open dialog and clears the init flag. */
(function () {
  function initCollectionPage(root) {
    if (!root || root.dataset.ascpInit === '1') return;
    root.dataset.ascpInit = '1';

    var dialogClass = root.dataset.ascpDialogClass;
    var dialogs = dialogClass
      ? Array.prototype.slice.call(document.querySelectorAll('dialog.' + dialogClass))
      : [];
    function dialogFor(key) {
      for (var i = 0; i < dialogs.length; i++) {
        if (dialogs[i].dataset.ascpModal === key) return dialogs[i];
      }
      return null;
    }
    function open(dlg) {
      if (!dlg) return;
      if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); }
      else dlg.setAttribute('open', '');
    }
    function close(dlg) {
      if (typeof dlg.close === 'function') dlg.close();
      else dlg.removeAttribute('open');
    }

    root.querySelectorAll('[data-ascp-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { open(dialogFor(btn.dataset.ascpOpen)); });
    });

    dialogs.forEach(function (dlg) {
      dlg.querySelectorAll('[data-ascp-close]').forEach(function (b) {
        b.addEventListener('click', function () { close(dlg); });
      });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) close(dlg);
      });
    });

    // sorting: keep every filter that is already applied, swap sort_by
    root.ownerDocument.querySelectorAll('[data-ascp-sort]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', btn.dataset.ascpSort);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });

    root.ascpCleanup = function () {
      dialogs.forEach(function (dlg) { if (dlg.open) close(dlg); });
      delete root.dataset.ascpInit;
    };
  }

  function initAll() {
    document.querySelectorAll('[data-as-collection-page]').forEach(initCollectionPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (e) {
    var scope = e && e.target && e.target.querySelectorAll ? e.target : document;
    scope.querySelectorAll('[data-as-collection-page]').forEach(function (root) {
      if (typeof root.ascpCleanup === 'function') root.ascpCleanup();
    });
  });
})();

